<form [formGroup]="kalenderForm" (ngSubmit)="speichern()">
    <h2 mat-dialog-title>Kalender anlegen/ändern</h2>
    <mat-dialog-content class="flex-container">
        <div class="flex-row flex-wrap gap-10" style="margin-top: 10px" data-cy="KalenderEditRow1">
            <mat-form-field data-cy="kalenderTitel" class="flex-grow flexbase-100">
                <mat-label>Titel</mat-label>
                <input matInput placeholder="Ex. Vorstand" formControlName="titel" />
            </mat-form-field>


                <div class="flex-grow flexbase-100">
                    <mat-label>Kalenderfarbe</mat-label><br />
                    <input type="color" formControlName="farbe"  data-cy="kalenderFarbe"/>
                </div>

                <div>
                    Soll der Kalender für alle (auch nicht eingeloggte Benutzer) öffenlich zugänglich sein?
                    <mat-checkbox class="flex-grow flexbase-100" formControlName="oeffentlich" data-cy="kalenderPublic">
                        Öffentlicher Kalender
                    </mat-checkbox>
                </div>

                <div formArrayName="rights" class="flexbase-100">
                    @for (rightForm of rights.controls; let i = $index; track rightForm) {
                        <div class="flex-grow flexbase-100 flex-row flex-wrap gap-10" [formGroupName]="i">
                            {{ rightForm.get('group')?.value }}

                            <mat-checkbox formControlName="read" data-cy="kalenderRead"> lesen </mat-checkbox>
                            <mat-checkbox formControlName="write" data-cy="kalenderWrite"> lesen/schreiben </mat-checkbox>
                        </div>
                    }
                </div>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (kalender.id) {
        <button mat-button (click)="delete()" type="button" data-cy="deleteBtn">Kalender löschen</button>
        }
        <button mat-button (click)="onCancel()" type="button" data-cy="closeBtn">Schließen</button>
        <button mat-button type="submit" data-cy="saveBtn">Speichern</button>
    </mat-dialog-actions>
</form>
